import "./ParentToolbox.module.css";
import ClassroomHeader from "@/reusable_sections/Header";
import BackpackEssentials from "./sections/BackpackEssentials";
import ImportantReminders from "./sections/ImportantReminders";
import ClassroomFooter from "@/reusable_sections/Footer";
export default function ParentToolboxPage() {
  return <div>
      <ClassroomHeader />
      <BackpackEssentials />
      <ImportantReminders />
      <ClassroomFooter />
    </div>;
}